module.exports = __webpack_public_path__ + "static/media/9x12no3.6f1a168d.jpg";